// src/models/sucursalModel.js

import pb from '../lib/pocketbase';

export async function getSucursales(page, perPage) {
  return await pb.collection('sucursal').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false
  });
}

export async function createSucursal(sucursal) {
  return await pb.collection('sucursal').create(sucursal);
}

export async function updateSucursal(id, sucursal) {
  return await pb.collection('sucursal').update(id, sucursal);
}

export async function deleteSucursal(id) {
  return await pb.collection('sucursal').delete(id);
}
